<div class="appHeader-leftSection">

<nav
    id="test-appMainMenu"
    class="component-appMenu"
    [ngClass]="{opened: mainMenuOpened}"
    (clickOutside)="mainMenuOpened = false"
    (mouseleave)="mainMenuLinkClicked ? mainMenuOpened = false : null">
    <div class="fa fa-bars" (click)="mainMenuToggle()"></div>
    <ul class="nativeScrollbar dark">
        <li *ngFor="let item of menu | menuConditions">
            <a
                class="fa {{item.class}}"
                (click)="mainMenuLinkClick(item)"
                [routerLink]="item.route"
                title="{{item.title}}">
                <span>
                    {{item.text}}
                </span>
            </a>
        </li>
    </ul>
</nav>

<section
    *ngIf="projects?.length > 1 || departments?.length > 0"
    class="component-dropdownSingleselect projects"
    [ngClass]="{'opened' : projectMenu == true && (projects.length > 1 || departments.length > 0),
               'oneProjectOnly': projects.length <= 1 && departments.length === 0}"
    (clickOutside)="projectMenu = false">
    <span
        [ngClass]="{'fa' : projects.length > 1 || departments.length > 0, 'fa-caret-down': projects.length > 1  || departments.length > 0}"
        (click)="projectMenu = !projectMenu"><span> {{ project.name }}
        <span *ngIf="selectedDepartment" title="středisko {{selectedDepartment.name}}">({{selectedDepartment.name}})</span>
        <span *ngIf="isUserAdmin && project.key?.indexOf('ca_agrofert_') === 0" class="agf-badge" title="Agrofert">A</span>
    </span>
    </span>

    <div class="component-dropdownSingleselect-content scrollable nativeScrollbar dark">
        <div class="component-searchField searchProject" *ngIf="projects?.length > 4">
            <input
                type="text"
                class="component-searchField-searchString"
                [ngClass]="schemaFilter ? 'filled' : 'empty'"
                [(ngModel)]="schemaFilter"
                focus-on="area-search-input"
                maxlength="25"/>
            <div class="fa"
                 [ngClass]="schemaFilter ? 'fa-times' : 'fa-search'"
                 (click)="schemaFilter = ''">
            </div>
        </div>
        <div>
            <ul *ngIf="projects?.length > 1 || departments?.length > 0">
                <li [ngClass]="{ 'selected' : project.key == p.key }"
                    *ngFor="let p of (projects | orderBy:'name' | displaySchemaFilter: schemaFilter);trackBy: p?.id">
                    <a (click)="changeProject(p.key);" id="test-projectName">
                        {{p.name}}
                        <span *ngIf="isUserAdmin && p.key?.indexOf('ca_agrofert_') === 0" class="agf-badge" title="Agrofert">A</span>
                    </a>
                    <ul *ngIf="project.key == p.key">
                        <li [ngClass]="{ 'selected' : selectedDepartment !== null && selectedDepartment.id === department.id }"
                            *ngFor="let department of (departments | orderBy:'name');trackBy: department?.id">
                            <a (click)="changeDepartment(department);">{{department.name}}</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</section>

<div class="breadcrumbs" [innerHtml]="breadcrumbsPath" (click)="logBreadcrumbsClick($event)">
</div>

</div>

<div class="appHeader-rightSection">

    <button type="button"
            class="component-commandPalette-trigger"
            id="test-openCommandPalette"
            (click)="openCommandPalette()"
            title="Hledat osoby, smlouvy, parcely nebo akce (zkratka: / nebo Ctrl+K)">
        <span class="fa fa-search" aria-hidden="true"></span>
        <span class="component-commandPalette-trigger-text">Hledat osoby, smlouvy, parcely…</span>
        <span class="component-commandPalette-trigger-kbds">
            <kbd>/</kbd>
            <span class="component-commandPalette-trigger-kbdOr">nebo</span>
            <kbd>Ctrl + k</kbd>
        </span>
    </button>

    <ca-bulk-operation-announcements></ca-bulk-operation-announcements>

    <div class="component-announcements component-tooltipContainer" (clickOutside)="hideNotifications()">
        <a *ngIf="notificationsCount > 0 || (notificationsCount === 0 && showNotifications === true)"
           (click)="toggleNotifications()" class="fa fa-bell" id="test-toggleNotifications">
            <span *ngIf="notificationsCount > 0" class="number">{{ notificationsCount}}</span>
        </a>
        <a *ngIf="notificationsCount === 0 && notificationsReadCount > 0 && showNotifications === false"
           (click)="toggleNotificationsRead()" class="fa fa-bell" id="test-toggleNotifications">
        </a>
        <a *ngIf="notificationsCount === 0 && notificationsReadCount === 0"
           (click)="toggleNoNotifications()" class="fa fa-bell" id="test-toggleNotifications">
        </a>
        <section class="component-tooltip positionedBottomRight pointerHeaderTopRight"
                 [ngClass]="{'opened': showNotifications === true}">
            <header>
                <h1 class="fa fa-bell">Oznámení</h1>
            </header>
            <div class="component-tooltip-content" >
                <ca-loading [loadState]="notificationsLoading">
                <ca-perfect-scrollbar class="filter-searchResults"
                      [featureKey]="psFeatureKey"
                      [componentKey]="perfectScrollbarKey"
                      [isVisible]="showNotifications"
                      [initialLoad]="true">

                    <table class="component-tabulatedList">
                        <tbody>
                            <tr *ngFor="let notification of notifications; trackByProperty: 'id'"
                                (click)="detailNotification(notification)">
                                <td>
                                    <span
                                        *ngIf="notification.notification.notificationType"
                                        class="fa"
                                        [ngClass]="getNotificationClass(notification)">
                                    </span>
                                </td>
                                <td>
                                    {{ notification.notification.perex}}
                                </td>
                                <td class="date"> {{ notification.notification.created | displayDate }} </td>
                                <td>
                                    <a (click)="readNotification(notification)" class="fa fa-times" title="Označit jako přečtené"></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ca-perfect-scrollbar>
                </ca-loading>
                <footer>
                    <a
                        (click)="toggleNotifications(); toggleNotificationsRead();"
                        *ngIf="notificationsReadCount > 0"
                        id="test-showReadNotifications"
                        class="button-secondary">
                        Zobrazit přečtená oznámení
                    </a>
                    <a
                        (click)="readAll()"
                        *ngIf="notificationsCount > 0"
                        id="test-readAllNotification"
                        class="button-secondary">
                        Všechna oznámení označit jako přečtená
                    </a>
                </footer>
            </div>
        </section>
        <section class="component-tooltip notificationsRead pointerHeaderTopRight" [ngClass]="{'opened': showNotificationsRead === true}">
            <header>
                <h1>
                    <a (click)="toggleNotificationsRead(); toggleNotifications();"
                       *ngIf="notificationsCount > 0"
                       class="fa fa-chevron-left">
                    </a>
                    Přečtená oznámení
                </h1>
            </header>
            <div class="component-tooltip-content" >
                <ca-loading [loadState]="notificationsReadLoading">
                <ca-perfect-scrollbar class="filter-searchResults"
                                      [featureKey]="psFeatureKey2"
                                      [componentKey]="perfectScrollbarKeyRead"
                                      [initialLoad]="true"
                                      [isVisible]="showNotificationsRead">
                    <table class="component-tabulatedList">
                        <tbody>
                            <tr *ngFor="let notification of notificationsRead;trackByProperty: 'id'"
                                (click)="detailNotification(notification)">
                                <td>
                                    <span
                                        *ngIf="notification.notification.notificationType"
                                        class="fa"
                                        [ngClass]="getNotificationClass(notification)">
                                    </span>
                                </td>
                                <td>
                                    {{ notification.notification.perex}}
                                </td>
                                <td class="date"> {{ notification.notification.created | displayDate }} </td>
                            </tr>
                        </tbody>
                    </table>
                </ca-perfect-scrollbar>
                </ca-loading>
            </div>
        </section>
        <section class="component-tooltip pointerHeaderTopRight" [ngClass]="{'opened': showNoNotification === true}">
            <header>
                <h1 class="fa fa-bell">
                    Oznámení
                </h1>
            </header>
            <div class="component-tooltip-content notificationNoSection">
                <p>Dosud Vám nebylo zasláno žádné oznámení. Můžete tedy nerušeně pokračovat v práci s aplikací.</p>
            </div>
        </section>
    </div>

    <div
        class="component-appMenu allignToRight"
        [ngClass]="{opened: userMenuOpened}"
        (clickOutside)="userMenuOpened = false">
        <div class="fa fa-caret-down-after" (click)="userMenuOpened = !userMenuOpened">
            <span class="name">{{customerName}}</span>
        </div>
        <ul class="nativeScrollbar dark">
            <li>
                <a
                    routerLink="/changePassword"
                    class="fa fa-key"
                    title="Klikněte pro změnu hesla.">
                    <span>Změna hesla</span>
                </a>
            </li>
            <li>
                <a
                    class="fa fa-info-circle"
                    (click)="showHelpdesk(); logUserMenuClick('helpdesk');"
                    title="Kontakty na náš helpdesk, který vám vždy vstřícně pomůže.">
                    <span>Kontakt na helpdesk</span>
                </a>
            </li>
            <li>
                <a
                    class="fa fa-question-circle"
                    href="http://www.cleverassets.cz/napoveda"
                    target="_blank"
                    (click)="logUserMenuClick('wiki');"
                    title="Manuály a instruktážní videa na naší wiki.">
                    <span>Nápověda</span>
                </a>
            </li>
            <li>
                <a
                    class="fa fa-desktop"
                    href="{{browserTestingURL}}"
                    target="_blank"
                    (click)="logUserMenuClick('test');"
                    title="Otestujte svůj prohlížeč, pokud máte podezření na pomalost aplikace.">
                    <span>Test prohlížeče a připojení</span>
                </a>
            </li>
            <li>
                <a
                    class="fa fa-comment"
                    href="https://help.center.cleverfarm.ag/servicedesk/customer/portal/50/group/152/create/319"
                    target="_blank"
                    (click)="logUserMenuClick('servicedesk');"
                    title="Vždy uvítáme vaše návrhy na vylepšení.">
                    <span>Návrhy na vylepšení</span>
                </a>
            </li>
            <li>
                <a
                    class="fa fa-heart-o"
                    href="https://www.cleverfarm.ag/cs/fanclub"
                    target="_blank"
                    (click)="logUserMenuClick('fanclub');"
                    title="Doporučte CleverFarm novému zákazníkovi a získejte odměnu.">
                    <span>FanClub CleverFarm</span>
                </a>
            </li>
            <li>
                <a
                    class="fa fa-gear"
                    *ngIf="editCuzkSettings"
                    (click)="showCuzkLogin(); logUserMenuClick('cuzk');"
                    title="Nastavte si přihlášení k dálkovému přístupu do ČÚZK.">
                    <span>Přihlášení do ČÚZK</span>
                </a>
            </li>
            <li>
                <a
                    class="fa fa-power-off"
                    (click)="performLogout();"
                    title="Klikněte pro bezpečné odhlášení z aplikace.">
                    <span>Odhlásit se</span>
                </a>
            </li>
        </ul>
    </div>
</div>